var _path, _line, _line2, _line3, _circle, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatetime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#000000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.66,54.45H8.84A2.5,2.5,0,0,1,6.35,52V12.12A2.49,2.49,0,0,1,8.84,9.63H48.68a2.49,2.49,0,0,1,2.49,2.49v22.4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.35,
    y1: 20.63,
    x2: 51.17,
    y2: 20.63
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16.46,
    y1: 9.63,
    x2: 16.46,
    y2: 4.63
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 40.42,
    y1: 9.63,
    x2: 40.42,
    y2: 4.63
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.22,
    cy: 45.44,
    r: 12.43
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "45.22 36.7 45.22 45.82 49.57 49.16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatetime);
export default __webpack_public_path__ + "static/media/datetime.61a695e6009cb53c24e1ae3989146704.svg";
export { ForwardRef as ReactComponent };